import {useState} from 'react';
import {Box, Button, Grid, Group, TextInput} from '@mantine/core';
import {useForm} from '@mantine/form';
import {ArrowRight} from "tabler-icons-react";
import { IAccount } from "features/accounts"
import {UsersSelect} from "features/users";


interface Props {
    onSubmitQuery?: (query: any) => void,
    initialValues?: any
}

export function AccountCreateForm({onSubmitQuery, initialValues}: Props) {
    const [creatingAccount, setCreatingAccount] = useState(false);
    const form = useForm<IAccount>({
        initialValues: initialValues || {},
        validate: {},
    });


    async function onSubmit(values: typeof form.values) {
        if (onSubmitQuery) {
            setCreatingAccount(true);
            await onSubmitQuery(values)
            setCreatingAccount(false);
        }
    }


    return (
        <Box mx="auto">
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Grid>
                    <Grid.Col sm={12}>
                        <TextInput label="Name" {...form.getInputProps('name')}/>
                    </Grid.Col>
                    <Grid.Col sm={12}>
                        <UsersSelect label="Account Executive" {...form.getInputProps('salesRep')}/>
                    </Grid.Col>
                    <Grid.Col sm={12}>
                        <Group position="right" mt="md">
                            <Button type="submit" loading={ creatingAccount }
                                    rightIcon={<ArrowRight/>}>
                                Add New Account
                            </Button>
                        </Group>
                    </Grid.Col>
                </Grid>
            </form>
        </Box>
    )
}
